import { FilterDataPointMetadataValue, FilterDataPointString } from '@/api/generatedApi';
import { FilterDataPopover } from './FilterDataPopover/FilterDataPopover';

type FilterConfig = {
  filterName: string;
  filterData: (FilterDataPointString | FilterDataPointMetadataValue)[];
  selectedFilterData?: FilterDataPointString | FilterDataPointMetadataValue;
  selectedFilterValues?: string[];
  recursive?: boolean;
  enableMultiSelect?: boolean;
  onRemove?: () => void;
  useJsonPayload?: boolean;
};

export const Filter = ({
  config,
  isStale,
  onFilterChange,
  readonly,
}: {
  config: FilterConfig;
  isStale?: boolean;
  onFilterChange: (filterName: string, filterValue: string | number | boolean | undefined) => void;
  readonly?: boolean;
}) => (
  <FilterDataPopover
    filterName={config.filterName}
    filterData={config.filterData}
    selectedFilterData={config.selectedFilterData}
    selectedFilterValues={config.selectedFilterValues}
    recursive={config.recursive}
    enableMultiSelect={config.enableMultiSelect}
    useJsonPayload={config.useJsonPayload}
    onFilterChange={(_checkedCount, value) => onFilterChange(config.filterName, value)}
    isStale={isStale}
    onRemove={isStale ? config.onRemove : undefined}
    readonly={readonly}
  />
);
